import SettingsModule from 'automation-ui-canvas/containers/settings/v2/SettingsModule';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIForm from 'UIComponents/form/UIForm';
import UIFormControl from 'UIComponents/form/UIFormControl';
import AssignableUserSelect from 'automation-ui-action-features/users-and-teams/AssignableUserSelect';
import TeamSelect from 'automation-ui-action-features/users-and-teams/TeamSelect';
import I18n from 'I18n';
import { View } from 'foundations-components/components/View';
import { InfoIcon } from 'foundations-assets';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const NotificationRecipientsSetting = ({
  readOnly,
  settings: {
    notifications
  },
  onChange
}) => {
  const subscribedTeamIds = notifications && notifications.subscribedTeamIds || [];
  const subscribedUserIds = notifications && notifications.subscribedUserIds || [];
  return /*#__PURE__*/_jsx(SettingsModule, {
    header: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "settingsV2.notificationRecipientsSetting.title"
    }),
    description: /*#__PURE__*/_jsx(UIFlex, {
      direction: "column",
      children: /*#__PURE__*/_jsx(UITooltip, {
        use: "longform",
        placement: "top",
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "platformSettings.notificationSubscriptions.recipientsTile.subtitleHelpTooltip"
        }),
        children: /*#__PURE__*/_jsxs("span", {
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: "platformSettings.notificationSubscriptions.recipientsTile.subtitle"
          }), /*#__PURE__*/_jsx(View, {
            as: "span",
            marginInlineStart: "100",
            children: /*#__PURE__*/_jsx(InfoIcon, {
              color: "icon-core-subtle"
            })
          })]
        })
      })
    }),
    body: /*#__PURE__*/_jsxs(UIForm, {
      children: [/*#__PURE__*/_jsx(UIFormControl, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "settingsV2.notificationRecipientsSetting.sendUsers"
        }),
        children: /*#__PURE__*/_jsx(AssignableUserSelect, {
          "data-test-id": "platform-settings-notifications-user-selector",
          multi: true,
          onChange: ({
            target: {
              value
            }
          }) => {
            const updatedNotificationSetting = Object.assign({}, notifications);
            updatedNotificationSetting.subscribedUserIds = value;
            onChange({
              notifications: updatedNotificationSetting
            });
          },
          placeholder: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "automation-ui-action-features.action-features.rotate-object.users-select.placeholder"
          }),
          overrideAssignableAccess: true,
          readOnly: readOnly,
          value: subscribedUserIds
        })
      }), /*#__PURE__*/_jsx(UIFormControl, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "settingsV2.notificationRecipientsSetting.sendTeams"
        }),
        children: /*#__PURE__*/_jsx(TeamSelect, {
          anchorType: "button",
          "data-test-id": "platform-settings-notifications-team-selector",
          multi: true,
          onChange: ({
            target: {
              value
            }
          }) => {
            const updatedNotificationSetting = Object.assign({}, notifications);
            updatedNotificationSetting.subscribedTeamIds = value;
            onChange({
              notifications: updatedNotificationSetting
            });
          },
          placeholder: I18n.text('automation-ui-action-features.action-features.rotate-object.teams-select.placeholder'),
          readOnly: readOnly,
          value: subscribedTeamIds
        })
      })]
    })
  });
};
export default NotificationRecipientsSetting;